var App = App || {};

App.VideoAccordions = (function ($) {
    'use strict';

    function init() {
        // Initially collapse all accordions and set aria-expanded to false
        $('.Jq-accordion-collapse').hide();
        $('.Jq-accordion-header').find("button").attr('aria-expanded', 'false');
        $('.Jq-accordion-header').click(function () {
            // Close all accordions
            $('.Jq-accordion-collapse').slideUp();
            $('.Jq-accordion-header').find("button").attr('aria-expanded', 'false');
            $('.Jq-accordion-header').find("button").addClass('collapsed');
            // Check if the clicked accordion is already open
            if (!$(this).next('.Jq-accordion-collapse').is(':visible')) {
                // Open the clicked accordion
                $(this).next('.Jq-accordion-collapse').slideDown();
                $(this).find("button").attr('aria-expanded', 'true');
                $(this).find("button").removeClass('collapsed');
            }
        });
        //Model popup close event
        $('#video-accordion-modal').on('hide.bs.modal', function () {
            $(this).find('#videoFrame').attr('src', '');
            $(this).find('#videoFrame').attr('title', '');
            $(this).find('.modal-desc').text("");
            setTimeout(function () {
                var imageActiveCount = $(".Jq-video-accordion-img").filter('[is-active="1"]').length;
                var podcastBtnActiveCount = $(".Jq-btnFullPodcast").filter('[is-active="1"]').length;
                if (imageActiveCount > 0) {
                    $(".Jq-video-accordion-img").filter('[is-active="1"]')[0].focus();
                    $(".Jq-video-accordion-img").filter('[is-active="1"]').attr("is-active", "0");
                }
                if (podcastBtnActiveCount > 0) {
                    $(".Jq-btnFullPodcast").filter('[is-active="1"]')[0].focus();
                    $(".Jq-btnFullPodcast").filter('[is-active="1"]').attr("is-active", "0");

                }
            }, 100);


        });
        //Click event for the video pop up
        $('.Jq-video-accordion-img,.Jq-btnFullPodcast').on('click', function () {
            var accordianImageCard = $(this).parents().filter(".Jq-video-accordion");
            let videoTitle = accordianImageCard.find(".video-popup-video-title").val();
            let videoSummary = accordianImageCard.find(".video-popup-video-summary").val();
            let videoTranscript = accordianImageCard.find(".video-popup-video-transcript").val();
            let videoSourceUrl = accordianImageCard.find(".video-popup-video-sourceUrl").val();
            $(this).attr("is-active", "1");
            $('#video-accordion-modal').find(".modal-title").text(videoTitle);
            if (videoSummary != undefined && videoSummary != null && videoSummary.trim().match("^<p>")) {
                var innerContent = videoSummary.replace(/^<p>/, '').replace(/<\/p>$/, '');
                $('#video-accordion-modal').find(".modal-desc").html(innerContent);
            }
            else {
                $('#video-accordion-modal').find(".modal-desc").text(videoSummary);
            }
            if (videoTranscript != undefined && videoTranscript != null && videoTranscript.trim() != "") {
                $('#video-accordion-modal').find(".Jq-btnVideoScript").attr("href", videoTranscript);
                $('#video-accordion-modal').find(".Jq-btnVideoScript").attr("aria-label", "Transcript of " + videoTitle);
                $('#video-accordion-modal').find(".video__transcript").show();
            }
            else {
                $('#video-accordion-modal').find(".Jq-btnVideoScript").removeAttr("href");
                $('#video-accordion-modal').find(".Jq-btnVideoScript").removeAttr("aria-label");
                $('#video-accordion-modal').find(".video__transcript").hide();
            }
            $('#video-accordion-modal').find('#videoFrame').attr("src", videoSourceUrl);
            $('#video-accordion-modal').find('#videoFrame').attr("title", videoTitle);
            $('#video-accordion-modal').modal('show');
        });
        //Enter key event for video accordion image 
        $('.Jq-video-accordion-img').keypress(function (e) {
            var key = e.which;
            if (key == 13)  // the enter key code
            {
                $(this).click();
            }
        });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.VideoAccordions.init();
});